module.exports = __webpack_public_path__ + "img/no-camera.4c2ac8de.svg";